import { Component, inject, LOCALE_ID } from "@angular/core";
import { PageHeaderComponent } from "../../../../../../shared-core/components/page-header/page-header.component";
import { SectionComponent } from "../../../../../../shared-core/components/section/section.component";
import { listStockTypeConfig } from "../../configs/list-stock-type.config";
import { filterStockTypeConfig } from "../../configs/filter-stock-type.config";
import { searchStockConfig } from "../../configs/search-stock-type.config";
import { IListStockTypeActionsParent } from "../../interfaces/list-stock-type-component.interface";
import { ListComponent } from "../../../../../../shared-core/components/list/list.component";
import { untilDestroyed } from "../../../../../../shared-core/helpers/until-destroy.helper";
import { ELocalizationLang } from "@app/shared-core/enums/localization-lang.enum";
import { StockTypeListService } from "../../services/stock-type-list.service";
import { PERMISSION_CONSTANTS } from "@app/shared/auth/constants/permissions.constant";
import { Router } from "@angular/router";
import { BreadCrumbComponent } from "@kernel/tools/bread-crumb/components/bread-crumb/bread-crumb.component";
import { baseBreadCrumb } from "@app/applications/stock/domains/stock-type/configs/bread-crumb-stock-type.config";
import { PageTitleService } from "@app/shared/general/services";

@Component({
  selector: "app-list-stock-type",
  imports: [PageHeaderComponent, SectionComponent, ListComponent, BreadCrumbComponent],
  templateUrl: "./list-stock-type.component.html",
  styleUrl: "./list-stock-type.component.scss",
})
export class ListStockTypeComponent implements IListStockTypeActionsParent {
  /**
   * Page title service for clean title management
   */
  pageTitle = inject(PageTitleService);

  /**
   * Handling Filter config for table
   */
  filterConfig = filterStockTypeConfig();
  /**
   * Handling Search config for table
   */
  searchConfig = searchStockConfig();
  /**
   * Handling table config for rendering the table
   */
  tableConfig = listStockTypeConfig(this);

  protected readonly breadCrumb = baseBreadCrumb;

  /**
   * Current locale ID for internationalization purposes.
   */
  lang = inject(LOCALE_ID) as ELocalizationLang;

  /**
   * Angular router for navigation.
   */
  router = inject(Router);

  /**
   * Service for handling table actions related to stock type.
   */
  stockTypeListService = inject(StockTypeListService);

  /**
   * Utility for handling subscription cleanup on component destruction.
   */
  takeUntilDestroy = untilDestroyed();

  createPermission = PERMISSION_CONSTANTS.STOCK_TYPE.CREATE;

  constructor() {
    this.pageTitle.setupTitle("STOCK_TYPE.TITLES.STOCK_TYPE");
  }
}
